import React from 'react';
import proptypes from 'prop-types';
const { number, string, func, bool, object, arrayOf, } = proptypes;
import { extend } from '@thd-nucleus/data-sources';
import { CheckAvailability } from '@thd-olt-component-react/check-availability';
import { dataModel } from './dataModel';
import { FulfillmentTiles } from './tiles/FulfillmentTiles';
import { FULFILLMENT_METHODS } from './constants';

const MajorApplianceFulfillment = (
  {
    itemId,
    storeId = null,
    configurableApplianceItemIds = null,
    quantity = 1,
    onChange = () => { },
    covidAlert = false,
    bopisMinimumThreshold = null,
    bopisMinimumThresholdStores = null,
    bopisHolidayTiming = null,
    directData = null,
    applianceDirectData = null,
    showZipCodeDrawer = false,
    defaultFulfillmentMethod = FULFILLMENT_METHODS.APPLIANCE
  }
) => {
  return (
    <>
      <FulfillmentTiles
        itemId={itemId}
        storeId={storeId}
        configurableApplianceItemIds={configurableApplianceItemIds}
        covidAlert={covidAlert}
        quantity={quantity}
        onChange={onChange}
        thresholds={{
          bopisMinimumThreshold,
          bopisMinimumThresholdStores,
          bopisHolidayTiming
        }}
        directData={directData}
        applianceDirectData={applianceDirectData}
        showZipCodeDrawer={showZipCodeDrawer}
        defaultFulfillmentMethod={defaultFulfillmentMethod}
      />
    </>
  );
};

MajorApplianceFulfillment.displayName = 'MajorApplianceFulfillment';

MajorApplianceFulfillment.propTypes = {
  /** An Item that has product highlights */
  itemId: string.isRequired,
  configurableApplianceItemIds: arrayOf(string),
  covidAlert: bool,
  storeId: string,
  quantity: number,
  onChange: func,
  bopisMinimumThreshold: number,
  bopisMinimumThresholdStores: string,
  bopisHolidayTiming: number,
  // eslint-disable-next-line react/forbid-prop-types
  directData: object,
  // eslint-disable-next-line react/forbid-prop-types
  applianceDirectData: object,
  showZipCodeDrawer: bool,
  defaultFulfillmentMethod: string
};

// ['identifiers', 'info', 'pricing', 'availabilityType', 'fulfillment']
MajorApplianceFulfillment.dataModel = extend(
  CheckAvailability,
  dataModel
);

export { MajorApplianceFulfillment };
